import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.jsx";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.jsx";

import sidebarStyle from "assets/jss/material-dashboard-react/components/sidebarStyle.jsx";
import "./Style/Sidebar.css";

const Sidebar = ({ ...props }) => {
  const [openDropdowns, setOpenDropdowns] = useState({});

  const handleDropdownToggle = (label) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  const { classes, color, logo, image, logoText, routes, user, permitPages, persona } = props;

  const isMobile = (window.innerWidth <= 760);

  let skipPage = ['Logout'];

  var links = (
    <List className={classes.list, "sidebarmenu"}>
      {routes.map((prop, key) => {
        if (prop.type === "dropdown") {
          const isOpen = openDropdowns[prop.label] || false;
          
          // Check if any sub-route should be shown
          const hasVisibleSubRoute = prop.route.some(subProp => {
            let showSubMenu = false;
            if (user.is_superuser == 1 && subProp.is_superuser) {
              if (subProp.role && subProp.role.indexOf(user && user.role) > -1) showSubMenu = true;
            } else {
              if (subProp.role && !subProp.is_superuser && subProp.role.indexOf(user && user.role) > -1) showSubMenu = true;
            }
            if (subProp.hide) showSubMenu = false;
            return showSubMenu;
          });

          if (!hasVisibleSubRoute) return null;

          return (
            <React.Fragment key={key}>
              <ListItem
                button
                onClick={() => handleDropdownToggle(prop.label)}
                className={classes.itemLink}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              >
                <Icon className={classNames(classes.itemIcon)} style={{ float: 'none', marginBottom: '0' }}>
                  <i className={prop.icon || "fa fa-list"} />
                </Icon>
                <ListItemText
                  primary={prop.label}
                  className={classNames(classes.itemText)}
                  disableTypography={true}
                  style={{ flex: 1 }}
                />
                {isOpen ? <ExpandLess className={classes.whiteFont} /> : <ExpandMore className={classes.whiteFont} />}
              </ListItem>
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {prop.route.map((subProp, subKey) => {
                    let showSubMenu = false;
                    if (user.is_superuser == 1 && subProp.is_superuser) {
                      if (subProp.role && subProp.role.indexOf(user && user.role) > -1) showSubMenu = true;
                    } else {
                      if (subProp.role && !subProp.is_superuser && subProp.role.indexOf(user && user.role) > -1) showSubMenu = true;
                    }
                    if (subProp.hide) showSubMenu = false;

                    if (showSubMenu && subProp.layout === "/admin") {
                      const listItemClasses = classNames({
                        [" " + classes[color]]: activeRoute(subProp.layout + subProp.path),
                      });
                      const whiteFontClasses = classNames({
                        [" " + classes.whiteFont]: activeRoute(subProp.layout + subProp.path),
                      });

                      return (
                        <NavLink
                          to={subProp.layout + subProp.path}
                          className={classes.item + " sidebar sub-item"}
                          activeClassName="active"
                          key={subKey}
                          style={{ paddingLeft: '20px' }}
                        >
                          <ListItem
                            button
                            className={classes.itemLink + listItemClasses}
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Icon className={classNames(classes.itemIcon, whiteFontClasses)} style={{ float: 'none', marginBottom: '0' }}>
                              <i className={subProp.icon} />
                            </Icon>
                            <ListItemText
                              primary={subProp.name}
                              className={classNames(classes.itemText, whiteFontClasses)}
                              disableTypography={true}
                              style={{ flex: 1 }}
                            />
                          </ListItem>
                        </NavLink>
                      );
                    }
                    return null;
                  })}
                </List>
              </Collapse>
            </React.Fragment>
          );
        }

        let showMenu = false;

        if (user.is_superuser == 1 && prop.is_superuser) {
          if (
            prop &&
            prop.role &&
            prop.role.indexOf(user && user.role) > -1
          ) {
            showMenu = true;
          }
        }
        else {
          if (
            prop &&
            prop.role &&
            !prop.is_superuser &&
            prop.role.indexOf(user && user.role) > -1
          ) {
            showMenu = true;
          }
        }
        
        if (prop.hide) {
          showMenu = false;
        }

        if (!prop.is_superuser && permitPages && ['owner'].indexOf(user && user.role) && !permitPages[prop.name] && !skipPage.includes(prop.name)) {
          showMenu = false;
        }

        if (persona && persona == 'Dialling' && (prop.name == 'Campaigns' || prop.name == 'Schedule')) {
          showMenu = false;
        }
        if (persona && persona == 'Dialling' && prop.name == 'Dialling') {
          showMenu = true;
        }

        if (showMenu && prop.layout === "/admin") {
          var activePro = " ";
          var listItemClasses;

          listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(prop.layout + prop.path),
          });

          const whiteFontClasses = classNames({
            [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path),
          });

          return (
            <NavLink
              to={prop.layout + prop.path}
              className={`${activePro + classes.item}  sidebar`}
              activeClassName="active"
              key={key}
            >
              <ListItem
                button
                className={`${classes.itemLink + listItemClasses} `}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {typeof prop.icon === "string" ? (
                  <Icon
                    className={classNames(classes.itemIcon, whiteFontClasses, {
                      [classes.itemIconRTL]: props.rtlActive,
                    })}
                    style={{ float: 'none', marginBottom: '0' }}
                  >
                    <i className={prop.icon} />
                  </Icon>
                ) : (
                  <prop.icon
                    className={classNames(classes.itemIcon, whiteFontClasses, {
                      [classes.itemIconRTL]: props.rtlActive,
                    })}
                    style={{ float: 'none', marginBottom: '0' }}
                  />
                )}
                <ListItemText
                  primary={props.rtlActive ? prop.rtlName : prop.name}
                  className={classNames(classes.itemText, whiteFontClasses, {
                    [classes.itemTextRTL]: props.rtlActive,
                  })}
                  disableTypography={true}
                  style={{ flex: 1 }}
                />
                {
                  prop.beta && (
                    <img className="beta" src="https://icon-library.com/images/beta-version-icon/beta-version-icon-6.jpg"/>
                  )
                }
              </ListItem>
            </NavLink>
          );
        }
      })}
    </List>
  );
  var brand = (
    <div className={`${classes.logo} `}>

      <a
        href=""
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive,
        })}
      >

        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
        {logoText}
      </a>





    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {<AdminNavbarLinks {...props} />}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(sidebarStyle)(Sidebar);
